<template>
  <section data-test="filter-sme-section">
    <div class="mt-2">
      <label class="from-label text-xxs text-gray-600" for="sme-select">ระดับความเปราะบาง</label>
      <v-select
        data-test="sme-select"
        id="sme-select"
        v-model="modelValueComputed"
        :options="sensitiveLevelOptions"
        :clearable="true"
        placeholder="กรุณาเลือกระดับความเปราะบาง"
        :appendToBody="true"
      >
        <template #no-options="">
          <p class="text-sm font-normal text-gray-500">
            ไม่พบข้อมูล
          </p>
        </template>
        <template #open-indicator="{ attributes }">
          <span v-bind="attributes"><ChevronDownIcon class="w-5 h-5"/></span>
        </template>
      </v-select>
    </div>
  </section>
</template>

<script setup>
import { computed, reactive, ref, watch, onMounted, onUnmounted } from "vue";
import { useStore } from "vuex";

const props = defineProps({
  modelValue: Number
});
const emits = defineEmits(["update:modelValue"]);

const store = useStore();


const sensitiveLevelOptions = reactive(
  ["0", "1", "2", "3"]
);

const modelValueComputed = computed({
  get() {
    return props.modelValue;
  },
  set(evt) {
    emits("update:modelValue", evt);
  },
});

</script>
